import { DocumentType } from '@verifime/utils';
import { DocumentInstructionsType } from './type';

export const DOCUMENT_INSTRUCTIONS: DocumentInstructionsType = {
  [DocumentType.Passport]:
    'Upload a photo of the first page of your passport showing your details clearly.',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  [DocumentType.ImmiCard]:
    'Upload a photo of the FRONT of your ImmiCard showing your details clearly.',
  [DocumentType.DriverLicence]: {
    main: "Upload photos of the FRONT AND BACK of your driver's licence. Make sure your photo and card number are clearly visible.",
    note: 'If you are using the Service NSW app, you may need to scroll down to be able to see your card number. Take two screenshots in this case to capture both your photo and card number.',
  },
  [DocumentType.MedicareCard]:
    'Upload a photo of the FRONT of your Medicare Card showing your details clearly.',
  // UNAPPROVED DRAFT (verifime-adr#816): to be approved with the stakeholder in the running build
  [DocumentType.PhotoCard]:
    'Upload photos of the FRONT AND BACK of your photo card or proof of age card. Make sure your photo and card number are clearly visible.',
  [DocumentType.OtherIdentityDocument]:
    'eg. a government-issued national ID card. Upload a photo of the document showing your details clearly.',
} as const;
